import { z } from 'zod';

export const brandSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  zip: z.string().nullable(),
  phone: z.string(),
  email: z.string(),
  website: z.string().nullable(),
  isDefault: z.boolean(),
});

export const brandListItemsSchema = z.object({
  variables: z.array(brandSchema),
});

export type Brand = z.infer<typeof brandSchema>;
export type BrandsListItems = z.infer<typeof brandListItemsSchema>;
